// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

function badgesWrapper(size) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(size)),
              BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.em(0.25)),
              BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.em(0.25))
            ]);
}

var Styles = {
  badgesWrapper: badgesWrapper
};

function AppStoreBadges(props) {
  var height = props.height;
  var height$1 = height !== undefined ? height : 40;
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: badgesWrapper(height$1)
            });
}

var Single;

var make = AppStoreBadges;

export {
  Styles ,
  Single ,
  make ,
}
/* react/jsx-runtime Not a pure module */
